module.exports = __webpack_public_path__ + "static/media/cloud-upload-orange.70956187.svg";